import React, { useState, useRef } from "react";
import { Row, Col, Form, Input, Select, Button, Drawer } from "antd";
import Keyboard from "react-simple-keyboard";
import Close from "../../../../assets/images/close-x.svg";
import data from "../../../../constants/retailPos.json";

const { Option } = Select;

const CardDetailsDrawer = ({
  isCardPaymentFlag,
  setIsCardPaymentFlag,
  CardPaymentForm,
  posConfig,
  setInputFocused,
  inputFocused,
  layoutName,
  setLayoutName,
  setSelectedPaymentMethod,
  handleCardPayment,
  inputName,
}) => {
  const [inputFields, setInputFields] = useState({ cardNumber: "" });
  const keyboardRef = useRef(null);

  const handleShift = () => {
    layoutName === "default" ? setLayoutName("shift") : setLayoutName("default");
  };

  const handleKeyboardInputs = (value) => {
    if (inputFocused) {
      const currentValue = CardPaymentForm.getFieldValue(inputFocused) || "";
      CardPaymentForm.setFieldsValue({
        [inputFocused]: `${currentValue}${value}`,
      });
    }
  };

  return (
    <Drawer
      closable={false}
      placement="bottom"
      title={
        <div style={{ display: "flex", alignItems: "center", height: "3vh", jusifyContent: "center", fontSize: "1vw", position: "relative" }}>
          <p
            style={{
              fontSize: "2vw",
              marginTop: "3vh",
              fontWeight: "500",
              color: "#2F3856",
              flex: 1,
              textAlign: "center",
            }}
          >
            Card Details
          </p>
          <img
            src={Close}
            onClick={() => {
              setSelectedPaymentMethod({});
              CardPaymentForm.resetFields();
              setIsCardPaymentFlag(false);
            }}
            style={{
              position: "absolute",
              right: "0.5vw",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      open={isCardPaymentFlag}
      className="filter"
      headerStyle={{ backgroundColor: "#f3f4f9", borderBottom: "none" }}
      styles={{ body: { backgroundColor: "#f3f4f9", paddingBottom: 0, paddingTop: 0 } }}
      onClose={() => {
        setSelectedPaymentMethod({});
        setIsCardPaymentFlag(false);
        CardPaymentForm.resetFields();
      }}
      height="87vh"
    >
      <Form layout="vertical" onFinish={handleCardPayment} form={CardPaymentForm}>
        <Row>
          <Col span={11} offset={1} style={{ paddingRight: "1vw" }}>
            <Row>
              <Col span={20} pull={2} push={2}>
                {posConfig?.transactionID === "Y" ? (
                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    name="transactionId"
                    rules={[
                      {
                        required: posConfig?.transactionID_mandatory === "Yes" ? true : false,
                        message: `Please enter Transaction ID`,
                      },
                    ]}
                    label={
                      <span
                        style={{
                          color: "#000",
                          fontSize: "1.2vw",
                          fontWeight: "500",
                        }}
                      >
                        Transaction ID
                      </span>
                    }
                  >
                    <Input
                      id="transactionId"
                      placeholder={`Transaction ID`}
                      onFocus={() => {
                        setInputFocused("transactionId");
                        setLayoutName("default");
                      }}
                      size="large"
                      onPressEnter={(e) => e.preventDefault()}
                      allowClear={false}
                      style={{
                        ...data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput,
                        padding: "2vh 1vw",
                      }}
                    />
                  </Form.Item>
                ) : (
                  ""
                )}
              </Col>
              <Col span={20} pull={2} push={2} style={{ padding: "" }}>
                {posConfig?.authorizationCode === "Y" ? (
                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    name="authorization"
                    rules={[
                      {
                        required: posConfig?.authorizationCode_mandatory === "Yes" ? true : false,
                        message: `Please enter Authorization Code`,
                      },
                    ]}
                    label={
                      <span
                        style={{
                          color: "#000",
                          fontSize: "1.2vw",
                          fontWeight: "500",
                        }}
                      >
                        Authorization Code
                      </span>
                    }
                  >
                    <Input
                      id="pin"
                      placeholder={`Authorization Code`}
                      size="large"
                      onPressEnter={(e) => e.preventDefault()}
                      onFocus={() => {
                        setInputFocused("authorization");
                        setLayoutName("default");
                      }}
                      allowClear={false}
                      style={{
                        ...data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput,
                        padding: "2vh 1vw",
                      }}
                    />
                  </Form.Item>
                ) : (
                  ""
                )}
              </Col>
              <Col span={20} pull={2} push={2}>
                {posConfig?.cardType === "Y" ? (
                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    name="cardType"
                    rules={[
                      {
                        required: posConfig?.cardType_mandatory === "Yes" ? true : false,
                        message: `Please enter Card Type`,
                      },
                    ]}
                    label={
                      <span
                        style={{
                          color: "#000",
                          fontSize: "1.2vw",
                          fontWeight: "500",
                        }}
                      >
                        Card Type
                      </span>
                    }
                  >
                    <Select className="selecItem" placeholder={<span className="cartSelect">Card Type</span>} size="large">
                      <Option className="cartOption" key="VI" value="VI">
                        Visa - VI
                      </Option>
                      <Option className="cartOption" key="MA" value="MA">
                        Master Card - MA
                      </Option>
                      <Option className="cartOption" key="RU" value="RU">
                        Rupay - RU
                      </Option>
                      <Option className="cartOption" key="AM" value="AM">
                        Amex - AM
                      </Option>
                      <Option className="cartOption" key="ME" value="ME">
                        Maestro - ME
                      </Option>
                    </Select>
                  </Form.Item>
                ) : (
                  ""
                )}
              </Col>
              <Col span={20} pull={2} push={2}>
                {posConfig?.CardNumber === "Y" ? (
                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    name="cardNumber"
                    rules={[
                      {
                        required: posConfig?.CardNumber_mandatory === "Yes" ? true : false,
                        message: `Please enter Card Number`,
                      },
                    ]}
                    label={
                      <span
                        style={{
                          color: "#000",
                          fontSize: "1.2vw",
                          fontWeight: "500",
                        }}
                      >
                        Card Number(Last 4 Digits)
                      </span>
                    }
                  >
                    <Input
                      id="redeemNumber"
                      placeholder={`Enter Number`}
                      onFocus={() => {
                        setInputFocused("cardNumber");
                        setLayoutName("numbers");
                      }}
                      size="large"
                      onPressEnter={(e) => e.preventDefault()}
                      allowClear={false}
                      style={{
                        ...data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput,
                        padding: "2vh 1vw",
                      }}
                    />
                  </Form.Item>
                ) : (
                  ""
                )}
              </Col>
            </Row>
          </Col>
          <Col span={11} style={{ padding: "" }}>
            <Row style={{ padding: "5% 1% 0 3.5%" }} gutter={[8, 6]}>
              <Keyboard
                theme={"hg-theme-default aprvl"}
                onChangeAll={(inputs) => {
                  setInputFields({ ...inputs });
                  CardPaymentForm.setFieldsValue(inputs);
                }}
                inputName={inputName}
                keyboardRef={(r) => (keyboardRef.current = r)}
                onKeyPress={(button) => {
                  const currentValue = CardPaymentForm.getFieldValue(inputFocused) || "";
                  if (inputFocused === "cardNumber") {
                    if (button.match(/^\d$/)) {
                      if (currentValue.length < 4) {
                        CardPaymentForm.setFieldsValue({
                          cardNumber: currentValue + button,
                        });
                      }
                      return;
                    } else if (button === "{backspace}") {
                      const currentValue = CardPaymentForm.getFieldValue(inputFocused) || "";
                      CardPaymentForm.setFieldsValue({
                        [inputFocused]: currentValue.slice(0, -1),
                      });
                    } else {
                      return;
                    }
                  }
                  if (button === "{shift}" || button === "{lock}") handleShift();
                  if (button === "{number}") {
                    setLayoutName("number");
                  }
                  if (button === "{numbers}") {
                    setLayoutName("numbers");
                  }
                  if (button === "{small}") {
                    setLayoutName("shift");
                  }
                  if (button === "{caps}") {
                    setLayoutName("default");
                  }
                  if (button === "{enter}") {
                  }
                  if (button === "{space}") {
                    const currentValue = CardPaymentForm.getFieldValue(inputFocused) || "";
                    CardPaymentForm.setFieldsValue({
                      [inputFocused]: `${currentValue} `,
                    });
                  } else if (button === "{backspace}") {
                    const currentValue = CardPaymentForm.getFieldValue(inputFocused) || "";
                    CardPaymentForm.setFieldsValue({
                      [inputFocused]: currentValue.slice(0, -1),
                    });
                  } else if (button !== "{enter}" && button !== "{shift}" && button !== "{caps}" && button !== "{numbers}") {
                    handleKeyboardInputs(button);
                  }
                }}
                layoutName={layoutName}
                display={{
                  "{abc}": "ABC",
                  "{smileys}": "\uD83D\uDE03",
                  "{back}": "Enter",
                  "{numbers}": "123",
                  "{number}": "123",
                  "{bksp}": "backspace",
                  "{backspace}": "⌫",
                  "{shift}": "⇧",
                  "{tab}": "tab",
                  "{lock}": "lock",
                  "{enter}": "Enter",
                  "{space}": "Space",
                  "{caps}": "ABC",
                  "{small}": "abc",
                }}
                layout={{
                  shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {backspace}", "{number} {space} {enter}"],
                  numbers: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{caps} {space} {enter}"],
                  number: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{small} {space} {enter}"],
                  default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}", "{numbers} {space} {enter}"],
                }}
              />
              <Col span={20} pull={2} push={2} style={{ padding: "3% 0", marginTop: "1%" }}>
                <Button
                  htmlType="submit"
                  style={{
                    backgroundColor: "#2F3856",
                    color: "#fff",
                    width: "100%",
                    fontSize: "1.2vw",
                    textAlign: "center",
                    fontWeight: "400",
                    borderRadius: "7px",
                    height: "8vh",
                  }}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </Drawer>
  );
};

export default CardDetailsDrawer;
